import { FixedArray } from '../utils/FixedArray';

export const MAX_HONEYCOMB_SIZE = 24;

interface IHoneyCombPositionsConfig {
    indicatorCenter: [number, number],
    hexagonOffsets: IHoneyCombPositions,
}

type IHexagonPosition = [number, number];

export type IHoneyCombPositions = FixedArray<IHexagonPosition, typeof MAX_HONEYCOMB_SIZE>;

const positions:  IHoneyCombPositionsConfig[] = [
    {
        indicatorCenter: [-325, 845],
        hexagonOffsets: [ [-1, 1], [-1, 0], [0, -1], [-2, 1], [-2, 0], [-2, -1], [-1, -1], [-3, 1], [-3, 0], [-3, -1], [-2, -2], [-1, -2], [-4, 1], [-4, 0], [-4, -1], [-4, -2], [-3, -2], [-2, -3], [-5, 1], [-5, 0], [-5, -1], [-5, -2], [-4, -3], [-3, -3] ]
    },
    {
        indicatorCenter: [-325, 480],
        hexagonOffsets: [ [0, 1], [-1, 1], [-1, 0], [-1, 2], [-2, 1], [-2, 0], [-1, 3], [-2, 2], [-3, 2], [-3, 1], [-3, 0], [-2, 3], [-3, 3], [-4, 2], [-4, 1], [-4, 0], [-2, 4], [-3, 4], [-4, 3], [-4, 4], [-5, 4], [-5, 3], [-5, 2], [-5, 1] ]
    },
    {
        indicatorCenter: [0, 305],
        hexagonOffsets: [ [-1, 1], [0, 1], [1, 1], [-2, 1], [-1, 2], [0, 2], [1, 2], [2, 1], [-2, 2], [-1, 3], [0, 3], [1, 3], [2, 2], [-3, 3], [-2, 3], [-1, 4], [0, 4], [1, 4], [2, 3], [3, 3], [-3, 4], [-2, 4], [2, 4], [3, 4] ]
    },
    {
        indicatorCenter: [325, 480],
        hexagonOffsets: [ [0, 1], [1, 1], [1, 0], [1, 2], [2, 1], [2, 0], [1, 3], [2, 2], [3, 2], [3, 1], [3, 0], [2, 3], [3, 3], [4, 2], [4, 1], [4, 0], [2, 4], [3, 4], [4, 3], [4, 4], [5, 4], [5, 3], [5, 2], [5, 1] ]
    },
    {
        indicatorCenter: [325, 845],
        hexagonOffsets: [ [1, 1], [1, 0], [0, -1], [2, 1], [2, 0], [2, -1], [1, -1], [3, 1], [3, 0], [3, -1], [2, -2], [1, -2], [4, 1], [4, 0], [4, -1], [4, -2], [3, -2], [2, -3], [5, 1], [5, 0], [5, -1], [5, -2], [4, -3], [3, -3] ]
    },
    {
        indicatorCenter: [0, 1040],
        hexagonOffsets: [ [-1, 0], [0, -1], [1, 0], [-2, -1], [-1, -1], [0, -2], [1, -1], [2, -1], [-2, -2], [-1, -2], [0, -3], [1, -2], [2, -2], [-3, -2], [-2, -3], [-1, -3], [0, -4], [1, -3], [2, -3], [3, -2], [-3, -3], [-2, -4], [2, -4], [3, -3] ]
    }
];

export class HoneycombConfigProvider {

    getPositions = ({ count }: { count: number }) => {
        if (count > 6) {
            throw new Error(`do not support positions for ${count} honeycombs`);
        }
        return [
            [positions[2]],
            [positions[1], positions[3]],
            [positions[1], positions[2], positions[3]],
            [positions[0], positions[1], positions[3], positions[4]],
            [positions[0], positions[1], positions[2], positions[3], positions[4]],
            [positions[0], positions[1], positions[2], positions[3], positions[4], positions[5]]
        ][count - 1];
    };
}
